import API from './API';

// -----------------------------------------------------------------------------
//  Motore di pianificazione (planner): geocodifica, slot liberi e scelta del
//  driver. Sono le tre chiamate che stanno DIETRO la creazione di un booking.
// -----------------------------------------------------------------------------

export default {
  // Indirizzo scritto a mano -> punto con lat/long. Senza coordinate il
  // planner non sa calcolare nulla: va fatta prima degli slot.
  // ⚠️ GOOGLE e non OpenStreetMap, che spesso non conosce i numeri civici e
  // metterebbe le sedi al centro della via.
  //
  // Le pagine si aspettano un ELENCO di risultati `{ label, point }` (la forma
  // di OpenStreetMap), Google ne restituisce uno solo: lo si mette in un
  // elenco, così nessuna pagina va toccata. Se Google non trova niente il
  // backend risponde 500, e le pagine lo trattano già come «non trovato».
  getPoints(text) {
    return API.post('/planner/maps-geocode', text).then((res) => ({
      ...res,
      data: res.data ? [res.data] : [],
    }));
  },

  // Orari liberi della giornata per quella tratta: torna un array di 'HH:mm'.
  calcSlot(deatl) {
    return API.post('/planner/slot-availables/', deatl);
  },

  // Sceglie il driver (e il jolly, dove serve) e CREA i planner della tratta:
  // restituisce { driver: { driverId, trips }, jolly, plannerDriver, plannerJolly }.
  //
  // ⚠️ NON usa gli status HTTP per gli errori: quando non trova un driver
  // risponde 200 con { error: "No drivers available for this hour" }. Va
  // controllato il corpo, altrimenti si prosegue con un planner inesistente.
  calcDuration(data) {
    return API.post('/planner/best-driver', data);
  },
};
